import {
  Directive,
  inject,
  input,
  InputSignal,
  OnDestroy,
} from '@angular/core';
import { HighlightChannel } from '../service/highlight.channels';
import { HighlightService } from '../service/highlight.service';
import { SearchChannel } from '../service/search.channels';
import { SearchService } from '../service/search.service';
import { AbstractSearchDirective } from './abstract-search.directive';

type SearchAndHighlightChannel = SearchChannel & HighlightChannel;

@Directive({
  selector: '[ngModel][appSearchAndHighlight]',
  exportAs: 'appSearchAndHighlight',
})
export class AppSearchAndHighlightDirective
  extends AbstractSearchDirective<SearchAndHighlightChannel>
  implements OnDestroy
{
  #searchService = inject(SearchService);

  #highlightService = inject(HighlightService);

  #isDestroyed = false;

  readonly appSearchAndHighlight = input<SearchAndHighlightChannel>();

  readonly channelInput: InputSignal<SearchAndHighlightChannel> = this
    .appSearchAndHighlight as InputSignal<SearchAndHighlightChannel>;

  protected setSearch(channel: SearchAndHighlightChannel, value: string) {
    if (this.#isDestroyed) {
      return;
    }

    this.#searchService.setSearch(channel, value);
    this.#highlightService.setSearch(channel, value);
  }

  ngOnDestroy() {
    this.#isDestroyed = true;

    const channel = this.channelInput();
    if (channel) {
      this.#searchService.reset(channel);
      this.#highlightService.reset(channel);
    }
  }
}
